import type { PhrasingContent, Root } from 'mdast';
import type { RegExpMatchObject } from 'mdast-util-find-and-replace';

import { findAndReplace } from 'mdast-util-find-and-replace';

export default function remarkTicketLinks() {
  return (tree: Root) => {
    findAndReplace(tree, [[/(?:#|\bgh-)([1-9]\d*)/gi, replaceTicket]]);

    function replaceTicket(
      value: string,
      no: string,
      match: RegExpMatchObject
    ): PhrasingContent | false {
      if (
        /\w/.test(match.input.charAt(match.index - 1)) ||
        /\w/.test(match.input.charAt(match.index + value.length)) ||
        // Probably trying to write a service order number like #2022-001
        /-/.test(match.input.charAt(match.index + value.length))
      ) {
        return false;
      }

      const companySlug = window.location.pathname.match(
        /\/company\/([a-z0-9-]+)\//
      )![1];
      const path = `/company/${companySlug}/tickets/${no}`;

      return path
        ? {
            type: 'link' as const,
            title: null,
            url: path,
            children: [{ type: 'text' as const, value }],
          }
        : false;
    }
  };
}
